import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { ButtonV2 } from '@zola/zola-ui';

import { DESKTOP_MIN, TABLET_MAX } from '../../../../lib/responsive';

import ButtonIconSquare from '../../../common/zolaUI/ButtonIconSquare/ButtonIconSquare';
import ChecklistAddTask from '../ChecklistAddTask';

import './ChecklistAddTaskButton.less';

class ChecklistAddTaskButton extends React.Component {
  constructor() {
    super();

    this.state = {
      expanded: false,
    };

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const isClickOutside = this.wrapperRef.current && !this.wrapperRef.current.contains(event.target);

    if (isClickOutside) {
      const { expanded } = this.state;

      if (expanded) {
        this.setState({
          expanded: false,
        });
      }
    }
  };

  toggleDropdown = () => this.setState(prevState => ({ expanded: !prevState.expanded }));

  render() {
    const { expanded } = this.state;
    const { disabled } = this.props;
    return (
      <div ref={this.wrapperRef} className="checklist__btn-container--add-task">
        <Media query={`(max-width: ${TABLET_MAX}px)`}>
          <ButtonIconSquare onClick={this.toggleDropdown} iconClassName="zola-ui-icon-plus">Add</ButtonIconSquare>
        </Media>
        <Media query={`(min-width: ${DESKTOP_MIN}px)`}>
          <ButtonV2
            compact
            className="checklist__button--add_task"
            onClick={this.toggleDropdown}
            disabled={disabled}
          >
            <i className="zola-ui-icon zola-ui-icon-plus checklist__addTask--icon" />
            Add Task
          </ButtonV2>
        </Media>
        {expanded && <ChecklistAddTask onClose={this.toggleDropdown} />}
      </div>
    );
  }
}

ChecklistAddTaskButton.propTypes = {
  disabled: PropTypes.bool,
};

ChecklistAddTaskButton.defaultProps = {
  disabled: false,
};

export default ChecklistAddTaskButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistAddTaskButton/ChecklistAddTaskButton.jsx